export const BaseUrl = "https://admin.ig-smart.com/wp-json/wp/v2/";
export const STANDARD_FORMAT = "?_fields=acf&acf_format=standard";
export const WOOCOMERCE_API_URL = 'https://admin.ig-smart.com/wp-json/wc/v3/products'
export const CONSUMER_KEY = "ck_e6e5ef5a3dc0f4817eb96bd14fe303d667399963";
export const CONSUMER_SECRET = "cs_8a40b638bf488958c57a10acfb2351d711809a43";
export const  ORDER_CONSUMER_KEY = "ck_0fc8e68b4367857da30154fee0a7582b1b79c302"; 
export const  ORDER_CONSUMER_SECRET = "cs_696f97a26cc7568cdca005685e8d83b03db5f161"; 
export const  PAYMENT_API = "https://admin.ig-smart.com/wp-json/custom/v1/process-payment"; 
export const  DOWNLOAD_PDF_API = "https://admin.ig-smart.com/wp-json/custom/v1/download-pdf"; 

/* Pages */ 
export const HOME_URL = "pages/27099";
export const CYBER_SECURITY_AUDIT = "pages/27240";
export const GDPR_NHS_CONSULTANCY = "pages/28242";
export const SDG = "pages/27337";
export const GDPR_AUDITORS_SERVICES = "pages/27381";
export const ISO_27001_AUDIT_SERVICES = "pages/27436";
export const RECORDS_MANAGMENT_AUDITING_AS_A_SERVICES = "pages/27478";
export const DPO_SERVICES = "pages/27527";
export const CSO_SERVICES = "pages/27577";
export const VCISO_SERVICES = "pages/27621";
export const DTAC_SERVICES = "pages/28119";
// export const CYBER_SECURITY_CONSULTANCY_SERVICES = "pages/27651";
export const CYBER_SECURITY_CONSULTANCY_SERVICES = "pages/27649";
export const ISO_27001_PENETRATION_TESTING = "pages/27813" ;
export const CALDICOTT_GURDIAN_TRAINING = "pages/27715";
export const DATA_PROTECTION_CONSULTANCY2 = "pages/27763";
export const NHS_INFORMATION_GOVERNANCE_CONSULTANCY = "pages/28269";
export const STORE = "pages/27742";
export const INFORMATION_GOVERNANCE_CONSULTANCY_SERVICES = "pages/28358";
export const BUSINESS_CONTINUITY = "pages/28066";
export const CLINICAL_GOVERNANCE = "pages/28392";
export const DATA_GOVERNANCE = "pages/28419";
export const MERGE_AQUISTION = "pages/28446";
export const SUPPLY_CHAIN = "pages/28467";
export const EU_REPRESENTATIVE = "pages/28492";
export const UK_REPRESENTATIVE = "pages/28515";
export const DATA_ASSEST_OWNER_TRAINING = "pages/28534";
export const DPO_TRAINING_HEALTH_SOCIAL_CARE = "pages/28554";
export const DPO_TRAINING_ONLINE = "pages/28388";
export const IG_GDPR_TRAINING = "pages/27850";
export const GDPR_NHS_TRAINING = "pages/27893";
export const INFORMATION_GOVERNANCE_TRAINING = "pages/27934";
export const LEGAL = "pages/27934";
export const DATA_PROTECTION_OFFICER_TRAINING_FOR_PHARMA = "pages/29064";
export const DATA_PRIVACY_TRAINING_FOR_PHARMA = "pages/29102";
export const CERTIFICATION_ISO_SERVICE = "pages/29191";
export const CERTIFICATION_CYBER_ESSENTIALS_CERTIFICATION_SERVICES = "pages/29222";
export const APPLICATION_SECURITY_AUDIT = "pages/29623";
export const IT_GENERAL_CONTROL_AUDIT = "pages/30183";
export const BIOMETRIC_DATA_PROTECTION = "pages/29674";
export const AI_PRIVACY_CONSULTATION = "pages/29643";
export const CYBER_SECURITY_RISK_AWARENESS = "pages/31264";

/* Legal And Compliance Pages */
export const LEGAL_AND_COMPLIANCE = "pages/29948";
export const ACCEPTABLE_USE_POLICY = "pages/29971";
export const CONFLICT_OF_INTEREST_POLICY = "pages/30004";
export const ANTI_MODERN_SLAVERY = "pages/30013";
export const ANTI_BRIBERY = "pages/30021";

/* Service Pages */ 
export const HIPPA_URL = "pages/28887";
export const NIST_URL = "pages/28914";
export const DATA_PRIVACY_CONSULTANCY = "pages/28939";
export const ENTERPRISE_RISK_MANAGMENT_CONSULTANCY = "pages/28963";
export const ISO_27001_CONSULTANCY = "pages/28987";
export const DISASTER_RECOVERY_CONSULTANCY = "pages/29011";
export const CYBER_RISK_AND_RESILIENCE = "pages/29039";
export const PRIVACY_INFORMATION_MANAGMENT_SYSTEM = "pages/29685";
export const PRIVACY_BY_DESIGN_CONSULTATION = "pages/29712";
export const GDPR_DATA_MAPPING_AND_INVENTORY = "pages/29742";
export const CCPA_AND_CPRA = "pages/29771";
export const PYSICAL_SECURITY_AUDIT = "pages/29792";
export const NETWORK_SECURITY_AUDIT = "pages/29826";
export const DATA_PRIVACY_COMPLIANCE_AUDIT = "pages/29858";
export const EXPERIENCE_EXCELLENCE_SMS_AUDIT = "pages/29879";
export const DATA_PRIVACY_IMPACT_ASSESSMENT = "pages/29906";
export const INCIDENT_RESPONSE_AND_MANAGMENT_SERVICE = "pages/29932";
export const BUISNESS_CONTINUITY_AND_DISASTER_RECOVERY_AUDIT = "pages/30157";
export const EXCUTIVE_RESOURCING = "pages/30438";
export const CERNER_EXCELLENCE = "pages/30461";
export const GDPR_COMPLIANCE = "pages/30498";
export const DATA_PROTECTION_AUDIT = "pages/30513";
export const DCB0129_URL = "pages/30910";
export const DCB0160_URL = "pages/30966";

/* Industries Page */ 
export const ACADEMIC_LIFE_SCIENCE = "pages/28620";
export const CENTRAL_AND_LOCAL_GOVERNMENT = "pages/28646";
export const CUSTOMER_LOYALITY_AND_REWARDS = "pages/28668";
export const FINANCE = "pages/28689";
export const HEALTH_AND_SOCIAL_CARE = "pages/28710";
export const INSURANCE_AND_LOSS_ADJUSTMENT = "pages/28732";
export const SERVICE_LEGAL = "pages/28753";
export const PHARACEUTIAL_AND_PHARMACOVIGILANCE = "pages/28777";
export const PROPERTY_INVESTMENT_MANAGMENT = "pages/28798";
export const RETAIL_AND_FMCG = "pages/28820";
export const SECURITY = "pages/28841";
export const TECHNOLOGY = "pages/28862";
export const AEROSPACE_AND_BORDER_CONTROL_ANVIGATING = "pages/29984";
export const CLIMATE_CHANGE_AND_ENVIORMENT = "pages/30037";
export const MERGE_AND_ACQUISITION = "pages/30050";
export const MEDIA_ENQUIRY = "pages/30064";
export const SPEAKER_ENQUIRY = "pages/30077";
export const COOKIE_TEMPLATE = "pages/30758";
export const CYBER_SECURITY_STORE = "pages/31218";
export const DATA_PRIVACY_STORE = "pages/31215";
export const CHARITY_NOT_FOR_PROFIT = "pages/30840";
export const CLINICAL_SAFETY_OFFICER_HANDBOOK = "pages/31351";

/* Reusable Component */  
export const TESTIMONIAL = "pages/27430";
export const TRAINING_TESTIMONIAL = "testimonial-react";
export const GET_IN_TOUCH = "pages/27434";
export const TEAM_SHOWCASE_POST = "team_showcase_post";

/* Posts */
export const POSTS  = "posts?_embed&";
export const POSTS1  = "posts";
export const POST_ACF  = "pages/27695";
export const POST_CATEGORIES  = "posts?categories=";
export const POST_CATEGORY_ID = "categories/?slug=";

/* Client Stories */ 
export const CLIENT_STORIES  = "successstories";
export const CLIENT_STORIES_PAGE  = "pages/29094";
export const INVESTOR  = "pages/29169";

/* Store */ 
export const GDPR_COMPLIANCE_TOOLKIT = "pages/30090";
export const ISO_27001_STORE = "pages/30112";
export const ISO_27001_ISMS = "pages/31053";
export const CAREER_URL = "pages/28194";

/* Image Slider */ 
export const IMAGE_SLIDER  = "pages/29131";

/* Contact Form 7*/
export const CONTACT_FORM_BASE_URL = "https://admin.ig-smart.com/wp-json/contact-form-7/v1/contact-forms/"
export const CONTACT_FORM_LAST_URL = "/feedback";
export const CONTACT_FORM_URL = "7434";
export const ENQUIRY_FORM_URL = "7812";
export const REQUEST_PROPOSAL_FORM_URL = "10276";

export const CONTACT_PAGE_FORM_URL = "31127";
export const SPEAK_TO_ADVISOR_URL = "31128";
export const CAREER_REQUEST_PROPOSAL = "31384";



 
